export const CHANGE_PROFILE_INFO_REQUEST =
  "PROFILE::CHANGE_PROFILE_INFO_REQUEST";
export const CHANGE_PROFILE_INFO_SUCCESS =
  "PROFILE::CHANGE_PROFILE_INFO_SUCCESS";
export const UPDATE_PROFILE_INFO_ACTION = "PROFILE::UPDATE_PROFILE_INFO_ACTION";
